import React from 'react';
import './App.css';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Routes from './routes/routes';
import { AuthProvider } from './contexts/auth';
import { BrowserRouter } from 'react-router-dom';

function App() {

  return (
    <BrowserRouter> 
      <AuthProvider>
        <Routes />
        <ToastContainer limit={1} />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
